/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Pagination, { bootstrap5PaginationPreset } from 'react-responsive-pagination';

const PageInfo = ({ pageInfo, handlePaging }) => {
  
  const [currentPage, setCurrentPage] = useState(1);
  
  useEffect(() => {
    setCurrentPage(pageInfo.number+1);
  },[]);

  useEffect(() => {
    setCurrentPage(pageInfo.number+1);
  },[pageInfo]);

  return (
    <div style={{maxWidth:"1000px", margin:"auto"}}>
      <Pagination
        {...bootstrap5PaginationPreset}
        current={currentPage}
        total={pageInfo.totalPages}
        onPageChange={handlePaging}
      />
    </div>
  );
}

export default PageInfo;